<template>
  <div class="mainpage">
      <div class="d-flex justify-content-between mb-2">
          <div class="d-flex">
          </div>
          <div class="d-flex justify-content-end">
                <Calendar ref="searchCalendar" @date-select="dateSearch" class="gap" v-model="date" showIcon  selectionMode="range" :manualInput="false" placeholder="Last 30 days" :maxDate="maxDate"/>
                <Button icon="pi pi-plus" label="Create New" @click="createLink"/>
          </div>
      </div>
      <div class="custom-table">
          <DataTable class="p-datatable" :value="getbulkLinkData" tableStyle="min-width: 50rem"
              v-model:expandedRows="expandedRows" dataKey="uuid"  @rowExpand="onRowExpand" @rowCollapse="onRowCollapse"
          >
              <template #empty>
                  <div class="empty-state"><img class="empty-state-image" src="@/assets/images/empty-state.svg"/></div>
                  <div class="empty-state">No data available</div>
              </template>
              <Column class="overflow-column" field="uploadName" header="Upload name" style="max-width: 20vw"></Column>
              <Column class="overflow-column" header="File name" style="max-width: 20vw">
                  <template #body="slotProps">
                      <div class="d-flex align-items-center h-100">
                          <span class="file-column" role="button" @click="download(slotProps.data.uuid)" >{{ slotProps.data.originalFileName }}</span>
                      </div>
                  </template>
              </Column>
              <Column class="overflow-column" field="status" header="Status" style="max-width: 20vw">
                <template #body="slotProps">
                      <div class="d-flex align-items-center h-100">
                          <span >{{ getStatus(slotProps.data.status) }}</span>
                      </div>
                  </template>
              </Column>
              <Column class="overflow-column" field="LastUpdated" header="Updated On" style="max-width: 20vw"></Column>
              <Column header="Actions" style="max-width: 20vw">
                  <template #body="slotProps">
                      <div class="d-flex align-items-center h-100">
                          <i role="button" class="pi pi-download mx-1" style="" @click="download(slotProps.data.uuid, true)" ></i>
                      </div>
                  </template>
              </Column>
              <Column expander style="width: 5rem" />
              <template #expansion="slotProps">
                  <div class="d-flex">
                      <!-- <div class="equal-sized-div"></div> -->
                      <div class="equal-sized-div">Rows Processed: <strong>{{ showNAIfEmpty(slotProps.data.RowsSubmitted) }}</strong></div>
                      <div class="equal-sized-div">Success:
                          <strong>{{ showNAIfEmpty(slotProps.data.RowsSuccess) }}</strong>
                          <!-- <i class="pi pi-download ml-1 point" style="margin-left:10px;" @click="downloadSampleFile" ></i> -->
                      </div>
                      <div class="equal-sized-div">Failed: <strong>{{ showNAIfEmpty(slotProps.data.RowsFailed) }}</strong></div>
                      <div class="equal-sized-div" v-if="slotProps.data.error">Error: <strong>{{ showNAIfEmpty(slotProps.data.error) }}</strong></div>
                  </div>
              </template>
          </DataTable>
          <Paginator :rows="rows" @page='fetchData' :totalRecords="getTotalUploads" :rowsPerPageOptions="[10, 20, 30]"></Paginator>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapModels } from '@/utils'
import { ctaTypeToNameMap, whitelistStatusMap } from '@/constants/index'
import moment from 'moment'
import Toastr from 'toastr'

export default {
    name: 'Bulk Shortening',
    components: {
    },
    data () {
        return {
            maxDate: null,
            rows: 10,
            searchValue: '',
            ctaType: '',
            filters: [ { label: 'Email', value: 'email' }, { label: 'Mobile', value: 'mobile' }, { label: 'URL', value: 'url' } ],
            date: [],
            startDay: '',
            endDay: '',
            ctaTypeToNameMap,
            whitelistStatusMap,
            expandedRows: [],
            ctaList: []
        }
    },
    methods: {
        createLink () {
            this.$router.push('/link/bulkcreate')
        },
        getStatus (status) {
            switch (status) {
            case 1:
                return 'COMPLETED'
            case 0:
                return 'PENDING'
            case -1:
                return 'SUSPENDED'
            case 4:
                return 'REJECTED'
            case 5:
                return 'BLACKLISTED'
            default:
                return 'ERROR'
            }
        },
        async dateSearch () {
            if (this.date[1] != null) {
                this.$refs.searchCalendar.overlayVisible = false
                await this.getUploads()
            }
        },
        async getUploads (page, rows) {
            this.startDay = ''
            this.endDay = ''
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                from: this.startDay,
                to: this.endDay
            }
            this.globalLoader = true
            await this.$store.dispatch('Links/Link/fetchFileUploads', { page: page, rows: rows, ...data })
            this.globalLoader = false
        },
        async fetchData (page, rows) {
            await this.getUploads(page, rows)
        },
        showNAIfEmpty (str) {
            return str === '' ? 'NA' : str
        },
        async download (uuid, processed = false) {
            try {
                let response = await this.$store.dispatch('Links/Link/downloadFile', { uuid, processed })
                if (response && response.status === 200 && response.data) {
                    const contentDisposition = response.headers['content-disposition']
                    let filename = 'data.csv'
                    if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename="(.+)"/)
                        if (filenameMatch.length === 2) {
                            filename = filenameMatch[1]
                        }
                    }

                    const blob = new Blob([response.data], { type: '.csv' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = filename
                    link.click()
                    URL.revokeObjectURL(link.href)
                } else {
                    Toastr.error('File not found')
                }
            } catch (error) {
                console.error(error)
                Toastr.error('Error occured while downloading file')
            }
        }

    },
    computed: {
        ...mapGetters({ currentUser: 'currentUser' }),
        ...mapModels('general', ['globalLoader']),
        ...mapModels('Cta/Whitelist', ['bulkctaList']),
        ...mapGetters('Links/Link', ['getTableData', 'getbulkLinkData', 'getTotalUploads']),
        filteredItems: function () {
            if (this.ctaList) {
                return this.ctaList.filter(item => {
                    if (this.searchValue && this.ctaType) {
                        return (item.Cta.toLowerCase().indexOf(this.searchValue.toLowerCase()) > -1) && (item.Type === this.ctaType)
                    }
                    if (this.searchValue) {
                        return item.Cta.toLowerCase().indexOf(this.searchValue.toLowerCase()) > -1
                    }
                    if (this.ctaType) {
                        return item.Type === this.ctaType
                    }
                    return item
                })
            } else {
                return []
            }
        }
    },
    async mounted () {
        this.maxDate = new Date()
        await this.fetchData(0, this.rows)
    }
}
</script>

<style>
.gap {
  margin-right: 0.5rem;
}
.overflow-column {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.overflow-column:hover {
  text-overflow: clip;
  white-space: normal;
  word-break: break-all;
}
.overflow-column-disable {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.equal-sized-div {
  width: 25%;
  float: left;
  box-sizing: border-box;
}
.point {
  cursor: pointer;
}
.file-column:hover {
  text-decoration: underline;
}
</style>
